<template>
  <div>
    <div class="lke-bg">
      <div class="lke-top">
        <div class="lke-top-l">您现在所在的位置：我的考试</div>
        <div class="lke-top-r" @click="openRouter('indexPage')">
          返回首页
          <i class="el-icon-arrow-down"></i>
        </div>
      </div>
      <!-- <div class="lke-mid" v-loading="listLoading">
        <div class="lke-mid-top">
          <i class="el-icon-s-order"></i>
          学习状态
        </div>
        <div class="lke-mid-fot">
          <div class="lke-tab1in">
            <div class="lke-tab1in-top">
              <i class="el-icon-star-on"></i>
              课程进度
            </div>
            <div class="lke-tab1in-fot">
              <span>全部课程</span>
              <div>
                <el-progress :percentage="Math.round(0 * 100)"></el-progress>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="lke-fot" v-loading="listLoading">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="入学考试" name="0" v-if="ruxueList.length > 0">
            <el-table :data="ruxueList" fit style="width: 100%">
              <el-table-column label="考试名称">
                <template slot-scope="{ row }">
                  <span>{{ row.examName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="考试时间" width="250px">
                <template
                  slot-scope="{ row }"
                  align="center"
                  v-if="row.examBegin"
                >
                  {{ row.examBegin | addtime }} — {{ row.examEnd | addtime }}
                </template>
              </el-table-column>
              <el-table-column label="进入考试" width="180">
                <template slot-scope="{ row }">
                  <el-button
                    v-if="gettime(row)"
                    size="mini"
                    type="primary"
                    @click="openExamination(row)"
                    >开始考试</el-button
                  >
                  <el-button v-else size="mini" type="warning"
                    >不在时间内</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="课程形考" name="1" v-if="examList.length > 0">
            <el-table :data="examList" fit style="width: 100%">
              <el-table-column label="考试名称">
                <template slot-scope="{ row }">
                  <span>{{ row.examName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="考试时间" width="250px">
                <template
                  slot-scope="{ row }"
                  align="center"
                  v-if="row.examBegin"
                >
                  {{ row.examBegin | addtime }} — {{ row.examEnd | addtime }}
                </template>
              </el-table-column>
              <el-table-column label="进入考试" width="180">
                <template slot-scope="{ row }">
                  <el-button
                    v-if="gettime(row)"
                    size="mini"
                    type="primary"
                    @click="openExamination(row)"
                    >开始考试</el-button
                  >
                  <el-button v-else size="mini" type="warning"
                    >不在时间内</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="课程终考" name="2" v-if="lastexamList.length > 0">
            <el-table :data="lastexamList" fit style="width: 100%">
              <el-table-column label="考试名称">
                <template slot-scope="{ row }">
                  <span>{{ row.examName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="考试时间" width="250px">
                <template
                  slot-scope="{ row }"
                  align="center"
                  v-if="row.examBegin"
                >
                  {{ row.examBegin | addtime }} — {{ row.examEnd | addtime }}
                </template>
              </el-table-column>
              <el-table-column label="进入考试" width="180">
                <template slot-scope="{ row }">
                  <el-button
                    v-if="gettime(row)"
                    size="mini"
                    type="primary"
                    @click="openExamination(row)"
                    >开始考试</el-button
                  >
                  <el-button v-else size="mini" type="warning"
                    >不在时间内</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <!-- <el-tab-pane label="考核结业" name="jieye">
                    </el-tab-pane> -->
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { getexam, getcourselist } from "@/api/index";
export default {
  props: {},
  data() {
    return {
      activeName: "0",
      url: "@/pages/index/assets/bird.jpeg",
      listLoading: false,
      completeness: 0,
      ruxueList: [],
      examList: [],
      lastexamList: [],
    };
  },
  computed: {
    examListX() {
            return this.$store.state.examListX;
        },
  },
  filters: {
    addtime(val) {
      return moment(val).format("YYYY-MM-DD");
    },
  },
  created() {
    this.getexam();
  },
  mounted() {},
  watch: {},
  methods: {
    getexam() {
      this.listLoading = true;
      // getcourselist().then(response => {
      //     this.completeness = response.completeness
      setTimeout(() => {
        if (this.examListX) {
          let list = this.examListX;
        for (let index = 0; index < list.length; index++) {
          list[index].examName = list[index].examInfo[0].name;
          list[index].exam = list[index].examInfo[0];
        }
        let ruxueList = [];
        let examList = [];
        let lastexamList = [];
        for (let index = 0; index < list.length; index++) {
          if (list[index].exam.type === 3) {
            ruxueList.push(list[index]);
          } else if (list[index].exam.type === 1) {
            examList.push(list[index]);
          } else if (list[index].exam.type === 2) {
            lastexamList.push(list[index]);
          }
        }
        if (ruxueList.length > 0) {
          this.activeName = "0";
        } else if (examList.length > 0) {
          this.activeName = "1";
        } else {
          this.activeName = "2";
        }
        this.ruxueList = ruxueList;
        this.examList = examList;
        this.lastexamList = lastexamList;
        this.listLoading = false;
        } else {
          getexam().then((response) => {
            this.$store.commit("examListX", response);
        let list = response;
        for (let index = 0; index < list.length; index++) {
          list[index].examName = list[index].examInfo[0].name;
          list[index].exam = list[index].examInfo[0];
        }
        let ruxueList = [];
        let examList = [];
        let lastexamList = [];
        for (let index = 0; index < list.length; index++) {
          if (list[index].exam.type === 3) {
            ruxueList.push(list[index]);
          } else if (list[index].exam.type === 1) {
            examList.push(list[index]);
          } else if (list[index].exam.type === 2) {
            lastexamList.push(list[index]);
          }
        }
        if (ruxueList.length > 0) {
          this.activeName = "0";
        } else if (examList.length > 0) {
          this.activeName = "1";
        } else {
          this.activeName = "2";
        }
        this.ruxueList = ruxueList;
        this.examList = examList;
        this.lastexamList = lastexamList;
        this.listLoading = false;
      });
        }
      }, 500);
      // })
    },

    gettime(val) {
      let examBegin = moment(val.examBegin).valueOf();
      let examEnd = moment(val.examEnd).valueOf()
      let time = moment().valueOf();
      if (examBegin <= time && examEnd > time) {
        return true;
      } else if (!val.examBegin && !val.examEnd) {
        return true;
      } else {
        return false;
      }
    },

    handleClick(tab, event) {
      if (this.activeName === "jieye") {
        let routeData = this.$router.resolve({
          name: "khjyIndex",
        });
        window.open(routeData.href, "_blank");
      }
    },

    openExamination(val) {
      this.$router.push({
        name: "examination",
        query: {
          paperId: val.exam._id,
          exambatchId: val._id,
        },
      });
    },

    openRouter(val) {
      this.$router.push({ name: val });
    },
  },
  components: {},
};
</script>

<style>
.el-tabs__item {
  font-size: 18px;
  letter-spacing: 1px;
}
.el-tabs__item.is-active {
  font-weight: 600;
}
</style>

<style scoped>
.lke-top {
  width: 1024px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
}
.lke-top-l {
  font-size: 16px;
  padding-left: 20px;
}
.lke-top-r {
  font-size: 16px;
  padding-right: 20px;
  cursor: pointer;
}
.lke-top-r:hover {
  color: #409eff;
}
.lke-mid {
  border: 1px solid #ccc;
  margin: 0 auto;
  width: 1024px;
  margin-bottom: 20px;
}
.lke-mid-top {
  padding: 10px 20px;
  font-size: 18px;
  color: #409eff;
  display: flex;
  align-items: center;
  font-weight: bold;
  border-bottom: 1px solid #ccc;
  background: #f7f7f7;
}
.lke-mid-top > i {
  font-size: 30px;
  padding-right: 20px;
}
.lke-mid-fot {
  padding: 20px 50px 20px 20px;
}
.lke-tab1in-top > i {
  font-size: 18px;
  color: #409eff;
}
.lke-tab1in-fot {
  display: flex;
  align-items: center;
  padding: 10px 0;
  padding-left: 90px;
}
.lke-tab1in-fot > span {
  font-size: 14px;
  color: #888888;
  padding-right: 50px;
}
.lke-tab1in-fot > div {
  flex: 1;
}
.lke-fot {
  margin: 0 auto;
  width: 1024px;
  border-top: 1px dashed #ccc;
  padding: 10px 0 50px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/wdks/wdks.vue